/**
 * Safe checklist JSON update. Lookup order: id -> step_id -> fallback name -> numeric index.
 */
export function safeUpdateChecklist(
  currentChecklist: unknown,
  targetId: string,
  updates: Record<string, unknown>,
  options?: { fallbackName?: string },
): unknown {
  if (currentChecklist && typeof currentChecklist === "object" && !Array.isArray(currentChecklist)) {
    const keys = Object.keys(currentChecklist);
    const isSimpleChecklist =
      keys.some((k) => ["requires_photo", "photo_required", "completed"].includes(k)) &&
      !keys.some((k) => k === "length");
    if (isSimpleChecklist) {
      return { ...(currentChecklist as Record<string, unknown>), ...updates };
    }
  }

  let normalizedArray: Record<string, unknown>[] = [];
  if (Array.isArray(currentChecklist)) {
    normalizedArray = [...(currentChecklist as Record<string, unknown>[])];
  } else if (currentChecklist && typeof currentChecklist === "object") {
    normalizedArray = Object.values(currentChecklist as Record<string, Record<string, unknown>>);
  }

  const itemIndex = normalizedArray.findIndex((item, idx) => {
    if (item?.id === targetId || item?.step_id === targetId) return true;
    if (
      options?.fallbackName &&
      (item?.name === options.fallbackName || item?.task_name === options.fallbackName)
    ) {
      return true;
    }
    if (!Number.isNaN(Number(targetId)) && idx === Number(targetId)) return true;
    return false;
  });

  if (itemIndex === -1) {
    console.warn("[safeUpdateChecklist] Nie znaleziono elementu. Dodaję nowy/naprawiam.", {
      targetId,
      fallbackName: options?.fallbackName,
    });
    if (normalizedArray.length === 1) {
      normalizedArray[0] = { ...normalizedArray[0], ...updates };
      return normalizedArray;
    }
    return normalizedArray;
  }

  normalizedArray[itemIndex] = {
    ...normalizedArray[itemIndex],
    ...updates,
    id: normalizedArray[itemIndex].id || targetId,
    updated_at: new Date().toISOString(),
  };

  return normalizedArray;
}
